import { render, staticRenderFns } from "./ControlDetalladoPagoDocentePorSedePage.vue?vue&type=template&id=52e65b00&scoped=true"
import script from "./ControlDetalladoPagoDocentePorSedePage.vue?vue&type=script&lang=js"
export * from "./ControlDetalladoPagoDocentePorSedePage.vue?vue&type=script&lang=js"
import style0 from "./ControlDetalladoPagoDocentePorSedePage.vue?vue&type=style&index=0&id=52e65b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e65b00",
  null
  
)

export default component.exports